import {
	ApolloClient,
	ApolloLink,
	ApolloProvider,
	HttpLink,
	InMemoryCache,
} from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { Router } from 'react-router-dom';
import { createBrowserHistory as createHistory } from 'history';
import moment from 'moment/min/moment-with-locales.min';
import AppRouter from './AppRouter';
import MainAppProvider from './MainAppProvider';
import { API_URL, CLIENT_VERSION } from '../config';
import ThemeProvider from '../UI/ThemeProvider';
import MainApp from '../template/MainAppContext';


export const bHistory = createHistory();
export { moment };

const retryLink = new RetryLink({
	delay: {
		initial: 1000,
		max: Infinity,
		jitter: true
	},
	attempts: {
		retryIf: error => {
			return error.message === 'Failed to fetch';
		}
	}
});

const httpLink = new HttpLink({
	uri: API_URL,
});

const authLink = setContext((_, { headers }) => {
	const token = sessionStorage.getItem('token');
	return {
		headers: {
			...headers,
			'x-jwt-token': token,
			'cbx-client-v': CLIENT_VERSION
		}
	};
});

const logoutLink = onError(({
	graphQLErrors, networkError
}) => {
	console.info(graphQLErrors);
	console.info(networkError);
});


export const client = new ApolloClient({
	link: ApolloLink.from([retryLink, authLink, logoutLink, httpLink]),
	cache: new InMemoryCache(),
	defaultOptions: {
		query: {
			fetchPolicy: 'network-only',
			errorPolicy: 'all'
		},
		mutate: {
			errorPolicy: 'all'
		}
	}
});

const App = () => (
	<ApolloProvider client={client}>
		<MainAppProvider>
			<ThemeProvider>
				<Router history={bHistory} >
					<MainApp>
						<AppRouter />
					</MainApp>
				</Router>
			</ThemeProvider>
		</MainAppProvider>
	</ApolloProvider >
);

export default App;
